module.exports = "/_next/static/images/cn-logo-e76967846203ea5f906e754383a8b345.png";